import { SearchaniseResponse, ResponseItem } from '../services/searchaniseService';
import { CollectionTileEmbeds, SearchaniseTagSeparator } from './constants';
import { selectors } from '../Constants';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const dot = require('dot');

dot.templateSettings = {
  ...dot.templateSettings,
  evaluate: /\{\$([\s\S]+?)\$\}/g,
  interpolate: /\{\$=([\s\S]+?)\$\}/g,
  encode: /\{\$!([\s\S]+?)\$\}/g,
  use: /\{\$#([\s\S]+?)\$\}/g,
  define: /\{\$##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\$\}/g,
  conditional: /\{\$\?(\?)?\s*([\s\S]*?)\s*\$\}/g,
  iterate: /\{\$~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\$\})/g,
  varname: 'it',
  strip: true,
  append: true,
  selfcontained: false,
};

const cardProductTemplate = document.getElementById('cardProductTmpl').innerHTML;
const cardProductPlaceholderTemplate = document.getElementById('cardProductTmplPlaceholder').innerHTML;
const customFeaturedImageTemplate = document.getElementById('customFeaturedImageTmpl').innerHTML;
const productFeaturedImageTemplate = document.getElementById('productFeaturedImageTmpl').innerHTML;
const tileEmbedTmplLink = document.getElementById('tileEmbedTmplLink').innerHTML;
const tileEmbedTmplNoLink = document.getElementById('tileEmbedTmplNoLink').innerHTML;

const formatPrice = (price: string) => global.Shopify.formatMoney(parseFloat(price) * 100);

const renderPlaceholder = () => {
  const productFn = dot.template(cardProductPlaceholderTemplate, undefined, {});

  return productFn({
    classes: 'card card-product product-item grid-item card--placeholder',
  });
};

const getProductLink = (collectionProductLink: string) => {
  if (!collectionProductLink) {
    return '';
  }

  const linkParts = collectionProductLink.split('/');
  const productHandle = linkParts[linkParts.length - 1];

  return `/products/${productHandle}`;
};

const renderProduct = (item: ResponseItem) => {
  const productFn = dot.template(cardProductTemplate, undefined, {
    customFeaturedImageTmpl: customFeaturedImageTemplate,
    productFeaturedImageTmpl: productFeaturedImageTemplate,
  });

  let customFeaturedImage;

  if (item.metafield_39644d622a6514670a8bcaddb03517f9) {
    customFeaturedImage = global.Shopify.Image.getSizedImageUrl(item.metafield_39644d622a6514670a8bcaddb03517f9, '360x');
  }

  const productFeaturedImage = item.shopify_images[0];
  const productFeaturedImageAlt = item.shopify_images_alt ? item.shopify_images_alt[0] : null;
  // eslint-disable-next-line max-len
  const productDiscountPercent = Math.round(((parseFloat(item.list_price) - parseFloat(item.price)) / parseFloat(item.list_price)) * 100);
  const rating = item.reviews_average_score ? (parseFloat(item.reviews_average_score) * 100) / 5
    : null;

  const parsedTemplate = productFn({
    classes: 'card card-product collection-card-product product-item grid-item',
    productId: item.product_id,
    productUrl: getProductLink(item.link),
    productTitle: item.title,
    productAvailable: parseInt(item.quantity, 10) > 0,
    productTags: item.tags.split(SearchaniseTagSeparator),
    productPriceVaries: item.shopify_variants.length > 1,
    productPrice: formatPrice(item.price),
    productCompareAtPrice: formatPrice(item.list_price),
    productOnSale: parseInt(item.discount, 10) > 0,
    rating,
    reviews: parseInt(item.total_reviews, 10) || null,
    productDiscountPercent,
    customFeaturedImage,
    productFeaturedImage,
    productFeaturedImageAlt,
  });

  return parsedTemplate;
};

const renderTileEmbed = (item: CollectionTileEmbeds[0]) => {
  const tileFn = dot.template(item.link ? tileEmbedTmplLink : tileEmbedTmplNoLink);

  return tileFn(item);
};

const findFacetByName = (facets: SearchaniseResponse['facets'], name: string) => facets.find((f) => f.title === name);

const updateFilter = (facets: SearchaniseResponse['facets'], filterName: string, filterId: string) => {
  const sidebarFiltersEl = document.querySelector('.js-sidebar-filters');
  const filterContentEl = sidebarFiltersEl.querySelector(`.js-filter-item__content[data-index="${filterId}"]`);

  if (!filterContentEl) {
    return;
  }

  const filterWrapperEl = filterContentEl.closest('.filter-item');
  const facet = findFacetByName(facets, filterName);

  if (!facet) {
    filterWrapperEl.classList.add('hidden');
    return;
  }

  filterWrapperEl.classList.remove('hidden');
  filterContentEl.setAttribute('data-facet-id', facet.attribute);
  const query = facet.buckets.map((b) => `[data-filter-wrapper="${b.value}"]`);

  const matchedFilterEls = filterContentEl.querySelectorAll(query.join(','));

  matchedFilterEls.forEach((el) => el.classList.remove('hidden'));
};

const updateFilters = (facets: SearchaniseResponse['facets']) => {
  const sidebarFiltersEl = document.querySelector('.js-sidebar-filters');
  const allFilters = sidebarFiltersEl.querySelectorAll('[data-filter-wrapper]');
  allFilters.forEach((el) => el.classList.add('hidden'));

  updateFilter(facets, 'Plant Size', 'plant-size');
  updateFilter(facets, 'Pet Friendly', 'pet-friendly');
  updateFilter(facets, 'Care Levels', 'care-level');
  updateFilter(facets, 'Light Levels', 'light-level');
  updateFilter(facets, 'Water Needs', 'water-level');
  updateFilter(facets, 'Humidity Levels', 'humidity-level');
  updateFilter(facets, 'Hardiness Zones', 'plant-zone');

  if (!document.querySelectorAll('.filter-item:not(.hidden)').length) {
    document.querySelector('.js-filters-list-wrapper').classList.add('hidden');
  }
};

const preselectFirstLoadFilters = (firstLoadApiFilters?: Record<string, string[]>) => {
  const sidebarFiltersEl = document.querySelector('.js-sidebar-filters');

  if (!firstLoadApiFilters) { return; }

  Object.keys(firstLoadApiFilters).forEach((facetId) => {
    const filterContentEl = sidebarFiltersEl.querySelector(`[data-facet-id=${facetId}]`);

    if (filterContentEl) {
      const filterValues = firstLoadApiFilters[facetId];
      const combinedSelector = filterValues.map((filter) => `.js-filter-checkbox[data-level="${filter}"]`).join(',');

      filterContentEl.querySelectorAll(combinedSelector).forEach((input: HTMLInputElement) => {
        input.setAttribute('checked', 'true');
      });

      const filterDropdown = filterContentEl.closest(selectors.expandable.item);
      filterDropdown.dispatchEvent(new CustomEvent('toggle-expandable'));
    }
  });
};

export const renderProductPlaceholders = () => {
  let placeholderHtml = '';

  for (let i = 0; i < 9; i += 1) {
    placeholderHtml += renderPlaceholder();
  }

  const productListEl = document.querySelector('.js-collection-view');
  productListEl.innerHTML += placeholderHtml;
};

export const hideProductPlaceholders = () => {
  const productListEl = document.querySelector('.js-collection-view');
  productListEl.querySelectorAll('.card--placeholder').forEach((placeholderEl) => {
    placeholderEl.remove();
  });
};

export const renderProducts = ({
  response,
  collectionTileEmbeds,
  hasMore,
  firstLoadFacetMap,
}: {
  response: SearchaniseResponse,
  collectionTileEmbeds: CollectionTileEmbeds;
  hasMore: boolean,
  firstLoadFacetMap?: Record<string, string[]>,
}) => {
  const productListEl = document.querySelector('.js-collection-view');
  const paginationWrapperEl = document.querySelector('.js-collections-pagination-wrapper');

  if (hasMore) {
    paginationWrapperEl.classList.remove('hidden');
  } else {
    paginationWrapperEl.classList.add('hidden');
  }

  let productHtml = '';

  response.items.forEach((item, index) => {
    const tileEmbed = collectionTileEmbeds.find((c) => (parseInt(c.position, 10) - 1) === index);

    if (tileEmbed) {
      productHtml += renderTileEmbed(tileEmbed);
    }

    productHtml += renderProduct(item);
  });

  productListEl.innerHTML += productHtml;

  updateFilters(response.facets);
  preselectFirstLoadFilters(firstLoadFacetMap);
};

export const renderBackupCollectionsBlock = () => {
  const backupCollectionsBlock = document.querySelector('.js-no-products-backup') as HTMLElement;
  backupCollectionsBlock.style.display = 'block';

  hideProductPlaceholders();
  const paginationWrapperEl = document.querySelector('.js-collections-pagination-wrapper');
  paginationWrapperEl.classList.add('hidden');
  updateFilters([]);
};

export const clearProducts = () => {
  const productListEl = document.querySelector('.js-collection-view');
  productListEl.innerHTML = '';
};

const closeMobileSidebar = () => {
  const sidebarEl = document.querySelector('.js-sidebar');
  const sidebarFiltersEl = document.querySelector('.js-sidebar-filters');
  const sidebarSortEl = document.querySelector('.js-sidebar-sort');
  const mainOverlayEl = document.getElementById('main-overlay');

  if (sidebarEl.classList.contains('is-active')) {
    sidebarEl.classList.add('is-closed');
    sidebarEl.classList.remove('is-active');
    mainOverlayEl.classList.remove('show');
    mainOverlayEl.classList.add('hide');
    sidebarFiltersEl.classList.remove('is-active');
    sidebarSortEl.classList.remove('is-active');
  }
};

export const setupMobileSidebar = () => {
  const sidebarEl = document.querySelector('.js-sidebar');
  const sidebarOpenEls = document.querySelectorAll('.js-sidebar-open');
  const sidebarCloseEl = document.querySelector('.js-sidebar-close');
  const sidebarOpenFiltersEl = document.querySelector('.js-sidebar-open-filters');
  const sidebarOpenSortEl = document.querySelector('.js-sidebar-open-sort');
  const sidebarFiltersEl = document.querySelector('.js-sidebar-filters');
  const sidebarSortEl = document.querySelector('.js-sidebar-sort');
  const mainOverlayEl = document.getElementById('main-overlay');

  sidebarOpenEls.forEach((sidebarOpenEl) => {
    sidebarOpenEl.addEventListener('click', () => {
      sidebarEl.classList.remove('is-closed');
      sidebarEl.classList.add('is-active');
      mainOverlayEl.classList.add('show');
      mainOverlayEl.classList.remove('hide');
    });
  });

  sidebarOpenFiltersEl.addEventListener('click', () => {
    sidebarFiltersEl.classList.add('is-active');
  });

  sidebarOpenSortEl.addEventListener('click', () => {
    sidebarSortEl.classList.add('is-active');
  });

  mainOverlayEl.addEventListener('click', closeMobileSidebar);
  sidebarCloseEl.addEventListener('click', closeMobileSidebar);
};
